//  @flow

import React from 'react';

import Banner from './Banner';
import ContactForm from './ContactForm';
import MapArea from './MapArea';
import ExploreCourses from '../../Components/ExploreCourse';
import LazyComponent from '../../Components/LazyComponent';
import Meta from '../../Components/Meta';

import './style.css';

const Contact = () => (
  <main>
    <Meta
      title="Contact Us | Alien Brains Educations"
      description="Long List of queries? Suggestions? Feel free to call or write to us. Even a simple query can lead to a million things you haven't really imagined off."
    />
    <Banner />
    <ContactForm />

    <LazyComponent>
      <MapArea />
    </LazyComponent>

    <LazyComponent>
      <ExploreCourses />
    </LazyComponent>
  </main>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/Pages/Contact/index.js